import "../assets/scss/components/_delivery-section.scss";
import type { DeliverySectionProps } from "../types/components/DeliverySectionProps";
import { DeliveryDate } from "./DeliveryDate";
import { DeliveryFormNew } from "./DeliveryFormNew";

export const DeliverySection = ({
	showDeliveryOptions = true,
	showFullAddress,
	setShowFullAddress,
}: DeliverySectionProps) => {
	return (
		<section className="delivery-section">
			<DeliveryDate showDeliveryOptions={showDeliveryOptions} />
			<br />
			<strong className="section-title">Fill in the recipient details:</strong>
			<p>Start adding in the delivery address below and we will do the rest.</p>

			<DeliveryFormNew showFullAddress={showFullAddress} setShowFullAddress={setShowFullAddress} />
		</section>
	);
};
